import { getField } from "vuex-map-fields";

export default {
  master(state) {
    return getField(state);
  },
  findState: state => state_id => {
    var state_obj = state.states.find(state => state.code === state_id);
    return state_obj ? state_obj : {};
  },
  findTestKit: state => test_kit_id => {
    var test_kit = state.testkits.find(testkit => testkit.id === test_kit_id);
    return test_kit ? test_kit : {};
  },
  findHowHeard: state => howheard_id => {
    var how_heard = state.howheard.find(
      howheard_obj => howheard_obj.id === howheard_id
    );
    return how_heard ? how_heard : {};
  },
  findRace: state => race_id => {
    var race = state.races.find(race => race.id === race_id);
    return race ? race : {};
  },
  findGender: state => gender_identity_id => {
    var gender = state.genders.find(gender => gender.id === gender_identity_id);
    return gender ? gender : {};
  },
  findClinic: state => clinic_id => {
    var clinic = state.clinics.find(clinic => clinic.id === clinic_id);
    return clinic ? clinic : {};
  },
  findSexWith: state => sex_with_id => {
    var sex_with = state.sexWiths.find(sex_with => sex_with.id === sex_with_id);
    return sex_with ? sex_with : {};
  },
  findSexAtBirth: state => sex_at_birth_id => {
    var sex_at_birth = state.sexAtBirths.find(sex_at_birth => sex_at_birth.id === sex_at_birth_id);
    return sex_at_birth ? sex_at_birth : {};
  },
};
